import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon, MinusIcon } from '@radix-ui/react-icons';

import { cn } from '@/utils/utils';
import { cva, VariantProps } from 'class-variance-authority';

const sizeVariants = cva('', {
  variants: {
    size: {
      default: 'size-4',
      lg: 'size-8',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export interface CheckboxProps
  extends
    React.ComponentProps<typeof CheckboxPrimitive.Root>,
    VariantProps<typeof sizeVariants> {}

const Checkbox = ({ className, size, ...props }: CheckboxProps) => (
  <CheckboxPrimitive.Root
    data-slot="checkbox"
    className={cn(
      'box-content peer shrink-0 rounded-sm border border-primary shadow-sm focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 bg-background data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground',
      sizeVariants({ size }),
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      // changed from flex because html2canvas wouldnt print flex svgs
      className={cn('block group leading-none text-current')}
    >
      <CheckIcon
        className={cn(
          'hidden group-data-[state=checked]:block mt-0',
          sizeVariants({ size })
        )}
        fill="white"
      />
      <MinusIcon
        className={cn(
          'hidden group-data-[state=indeterminate]:block mt-0',
          sizeVariants({ size })
        )}
        fill="white"
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
